import { render, staticRenderFns } from "./auditDetail.vue?vue&type=template&id=6ff721ee&"
import script from "./auditDetail.vue?vue&type=script&lang=js&"
export * from "./auditDetail.vue?vue&type=script&lang=js&"
import style0 from "./auditDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "auditDetail.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VCard,
  VCardText,
  VContainer,
  VDataTable,
  VFlex,
  VIcon,
  VLayout,
})
